export default __webpack_public_path__ + "static/media/img-play-video.e69229d9.jpg";